import { store, storeModuleTypes, environmentGetterTypes } from 'vue-infra';
import { STATE_KEYS } from './state';
import { $get } from './helpers';

const GETTER_TYPES = {
  GET_APPS: 'getApps',
  GET_GROUPS: 'getGroups',
  GET_DISABLED_APPS: 'getDisabledApps',
  GET_ACTIVE_ROUTE: 'getActiveRoute',
  GET_ACTIVE_ROUTE_PARAMS: 'getActiveRouteParams',
  GET_IFRAME_STATES: 'getIframeStates',
  GET_LD_FLAGS: 'getLDFlags',
  GET_LOCALE: 'getLocale',
};

export function getActiveRouteParams() {
  return $get(null, GETTER_TYPES.GET_ACTIVE_ROUTE_PARAMS);
}

export function getIFrameState(namespace) {
  const states = $get(null, GETTER_TYPES.GET_IFRAME_STATES);
  return states[namespace];
}

export function getCurrentTheme() {
  return store.getters[`${storeModuleTypes.ENVIRONMENT}/${environmentGetterTypes.CURRENT_ACTIVE_THEME}`];
}

const getters = {
  [GETTER_TYPES.GET_APPS](state) {
    return state[STATE_KEYS.APPS];
  },
  [GETTER_TYPES.GET_GROUPS](state) {
    return state[STATE_KEYS.GROUPS];
  },
  [GETTER_TYPES.GET_DISABLED_APPS](state) {
    return state[STATE_KEYS.DISABLED_APPS];
  },
  [GETTER_TYPES.GET_ACTIVE_ROUTE](state) {
    return state[STATE_KEYS.ACTIVE_ROUTE];
  },
  [GETTER_TYPES.GET_ACTIVE_ROUTE_PARAMS](state) {
    return state[STATE_KEYS.ACTIVE_ROUTE_PARAMS];
  },
  [GETTER_TYPES.GET_IFRAME_STATES](state) {
    return state[STATE_KEYS.IFRAME_STATES];
  },
  [GETTER_TYPES.GET_LD_FLAGS](state) {
    return state[STATE_KEYS.LD_FLAGS];
  },
  [GETTER_TYPES.GET_LOCALE](state) {
    return state[STATE_KEYS.LOCALE];
  },
};

export {
  getters,
  GETTER_TYPES,
};
